<style scoped>
/*WARNING: vue-atlaskit styles are imported as static synchronizer backend resources(FILE IS CUT OFF FROM GLOBAL STYLES), */
/*if anything goes wrong with atlaskit components view please ensure that Content/css/vue-atlaskit.css is up to date*/
    .default-mapping-row {
        margin: 0 auto;
        width: 75%;
    }
    .fieldlistleft, .fieldlistright {
        padding: 10px 0;
    }
    .tfs4jira-mapping-row-direction-jira-to-tfs,
    .tfs4jira-mapping-row-direction-tfs-to-jira {
        background-repeat: no-repeat;
        background-size: 80px 20px;
        display: block;
        height: 20px;
        width: 80px;
        margin: 0 auto;
    }
    select:disabled {
        background-color: #f3f3f3;
    }
</style>
<template>
    <div>
        <div class="default-mapping-row">
            <div class="fieldlistleft">
                <UserSelect 
                    v-model="defaultJiraAction" 
                    :options="jiraSpecialValuesExtended" 
                    :disabled="waitingForResponse"
                    :searchable="false"
                    class="default-value-or-action-select"
                />

                <UserSelect 
                    v-show="defaultJiraAction && defaultJiraAction.key === 'Set value'"
                    v-model="defaultJiraValue" 
                    :disabled="waitingForResponse"
                    :options="availableValues.JiraValues"
                    class="default-value-select default-value-or-action-select"
                    :is-fetching="isFetchingJiraValue"
                    :async="true"
                    @search-change="onGetJiraValues"
                />
            </div>
            <div class="fieldlistmiddle">
                <div class="tfs4jira-mapping-row-direction-tfs-to-jira"></div>
            </div>
            <div class="fieldlistright"><i>anything else</i></div>
        </div>
        <div class="default-mapping-row">
            <div class="fieldlistleft"><i>anything else</i></div>
            <div class="fieldlistmiddle">
                <div class="tfs4jira-mapping-row-direction-jira-to-tfs"></div>
            </div>
            <div class="fieldlistright">
                <UserSelect 
                    v-model="defaultTfsAction" 
                    :options="tfsSpecialValuesExtended" 
                    :disabled="waitingForResponse"
                    :searchable="false"
                    class="default-value-or-action-select"
                />

                <UserSelect 
                    v-show="defaultTfsAction && defaultTfsAction.key === 'Set value'"
                    v-model="defaultTfsValue" 
                    :disabled="waitingForResponse"
                    :options="availableValues.TfsValues"
                    class="default-value-select default-value-or-action-select"
                    :useCustomFiltering="true"
                />
            </div>
        </div>
    </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import axios from 'axios';
import { NAMESPACE as USERS_MAPPING_NAMESPACE } from '../../store/modules/usersMapping.js';
import UserMappingsService from '../../service/usersMapping.js';
import UserSelect from './UserSelect.vue';
import pDebounce from 'p-debounce';

const debounceTimeMs = 300;

const SET_VALUE_ACTION = {
    key: 'Set value',
    label: 'Set value'
};

export default {
    props: {
        profileGuid: String,
        contextPath: String,
        loadOnInit: String
    },
    components: {
        UserSelect
    },
    data() {
        return {
            defaultJiraAction: {},
            defaultJiraValue: {},
            defaultTfsAction: {},
            defaultTfsValue: {},
            isFetchingJiraValue: false,
        }
    },
    computed: {
        ...mapGetters({
            defaultValues: USERS_MAPPING_NAMESPACE.getters.DEFAULT_VALUES,
            availableValues: USERS_MAPPING_NAMESPACE.getters.AVAILABLE_VALUES,
            specialValues: USERS_MAPPING_NAMESPACE.getters.SPECIAL_VALUES,
            waitingForResponse: USERS_MAPPING_NAMESPACE.getters.IS_LOADER_VISIBLE
        }),
        jiraSpecialValues() {
            return [...this.specialValues.filter(value => value.kind === 'JIRA')];
        },
        jiraSpecialValuesExtended() {
            return [...this.jiraSpecialValues, SET_VALUE_ACTION];
        },
        tfsSpecialValues() {
            return this.specialValues.filter(value => value.kind === 'TFS');
        },
        tfsSpecialValuesExtended() {
            return [...this.tfsSpecialValues, SET_VALUE_ACTION];
        },
    },
    created() {
        this.onGetJiraValues = pDebounce(this.onGetJiraValues, debounceTimeMs);
    },
    methods: {
        ...mapActions({
            setUpService: USERS_MAPPING_NAMESPACE.actions.SET_UP_SERVICE,
            getDefaultValues: USERS_MAPPING_NAMESPACE.actions.GET_DEFAULT_VALUES,
            updateTfsDefaultValue: USERS_MAPPING_NAMESPACE.actions.UPDATE_TFS_DEFAULT_VALUE,
            updateJiraDefaultValue: USERS_MAPPING_NAMESPACE.actions.UPDATE_JIRA_DEFAULT_VALUE,
            getJiraValues: USERS_MAPPING_NAMESPACE.actions.GET_JIRA_VALUES,
        }),
        initComponent: async function() {
            this.setUpService({
                prefix: this.contextPath + '/api/profiles/' + this.profileGuid,
                service: new UserMappingsService(axios)
            });
            await this.getDefaultValues();
        },
        tryToAddEmailToTfsDefaultValue() {
            const tfsValueFromAvailableValues = this.availableValues.TfsValues.find((value) => value.id === this.defaultTfsValue.id);
            if (tfsValueFromAvailableValues) {
                this.defaultTfsValue.email = tfsValueFromAvailableValues.email;
            }
        },
        async onGetJiraValues(query) {
            if(query === "") return;
            this.isFetchingJiraValue = true;
            await this.getJiraValues({ query, filterMappedUsers: false });
            this.isFetchingJiraValue = false;
        }
    },
    watch: {
        loadOnInit: {
            handler(newValue, oldValue) {
                if (newValue != oldValue && newValue === 'true') {
                    this.initComponent();
                }
            }
        },
        defaultValues(newVal, oldVal) {
            if (newVal.JiraValue && newVal.JiraValue !== oldVal.JiraValue) {
                if (this.jiraSpecialValues.find((val) => val.id === newVal.JiraValue.id)) {
                    this.defaultJiraAction = newVal.JiraValue;
                } else {
                    this.defaultJiraAction = SET_VALUE_ACTION;
                    this.defaultJiraValue = newVal.JiraValue;
                }
            }
            if (newVal.TfsValue && newVal.TfsValue !== oldVal.TfsValue) {
                if (this.tfsSpecialValues.find((val) => val.id === newVal.TfsValue.id)) {
                    this.defaultTfsAction = newVal.TfsValue;
                } else {
                    this.defaultTfsAction = SET_VALUE_ACTION;
                    this.defaultTfsValue = newVal.TfsValue;
                }
            }
        },

        defaultJiraAction(newVal, oldVal) {
            if (!newVal) return;
            if (newVal === SET_VALUE_ACTION && Object.keys(oldVal).length !== 0) {
                this.defaultJiraValue = {};
                return;
            }
            if (!this.jiraSpecialValues.includes(newVal)) return;
            if (newVal === this.defaultValues.JiraValue) return;
            this.updateJiraDefaultValue(newVal);
        },
        defaultJiraValue(newVal, oldVal) {
            if (!newVal) return;
            if (newVal === this.defaultValues.JiraValue) return;
            this.updateJiraDefaultValue(newVal);
        },

        defaultTfsAction(newVal, oldVal) {
            if (!newVal) return;
            if (newVal === SET_VALUE_ACTION && Object.keys(oldVal).length !== 0) {
                this.defaultTfsValue = {};
                return;
            }
            if (!this.tfsSpecialValues.includes(newVal)) return;
            if (newVal === this.defaultValues.TfsValue) return;
            this.updateTfsDefaultValue(newVal);
        },
        defaultTfsValue(newVal, oldVal) {
            if (!newVal) return;
            if (newVal === this.defaultValues.TfsValue) return;
            this.updateTfsDefaultValue(newVal);
        },

        availableValues() {
            if (!this.defaultTfsValue.email) {
                this.tryToAddEmailToTfsDefaultValue();
            }
        }
    },
    mounted: function() {
        if (this.loadOnInit !== undefined && this.loadOnInit === 'true') {
            this.initComponent();
        }
    }
}
</script>

<style>
.default-value-or-action-select .clear-icon {
    display: none;
}
</style>

<style scoped>
.default-value-select{
    margin-top: 6px !important;
}
</style>


// WEBPACK FOOTER //
// src/components/users/UsersMappingDefault.vue